import { DATA_STORE } from "../DataStore";
import {
  assetIDsToImageURLS,
  checkImageInViewport,
  loadJson,
  PRNG,
  isScrollingToBottom,
  scroll,
} from "../utils";
import Content from "../Content";
import SearchField from "../SearchField";
import EventEmitter from "eventemitter3";
import Bookmark from "./Bookmark";
import AxL from "../axl";
import EmptyResult from "./EmptyResult";
let CONTAINER, SAVED;
export default class Layout extends EventEmitter {
  constructor(USE_WORKER = false, axl = null, tracker = null, tooltips = null) {
    super();

    //use workers ?
    this.USE_WORKER = USE_WORKER;
    this.axl = axl;
    this.tracker = tracker;
    this.toolTips = tooltips;

    // preloading
    this.loading = false;
    this.pool = [];
    this.handlers = {
      onFirstContentLoaded: this.onFirstContentLoaded.bind(this),
      onLodComplete: this.onLodComplete.bind(this),
      onProgress: this.onProgress.bind(this),
    };

    //start loop
    this.visibilityCheck(); //TODO : freeze on Axl FREEZE

    // searchfield
    this.search = new SearchField();
    this.search.on("select", (tag, assets, type) => {
      this.emit("search-result", tag, assets, type);
    });

    // builds a container
    CONTAINER = document.createElement("div");
    //listen to tag clicks
    CONTAINER.addEventListener("click", (e) => {
      if (e.target.classList.contains("tag") == true) {
        const tag = e.target.getAttribute("tag");
        console.log("tag >", tag);
        this.emit("tag-clicked", tag);
      }
    });

    document.querySelector(".letter").appendChild(CONTAINER);

    // save/restore state
    SAVED = "";

    // keep ref for each content
    this.contents = [];
  }
  iOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  // remove all the children
  clear() {
    const e = CONTAINER;
    while (e.children.length) e.removeChild(e.children[0]);
  }

  saveState() {
    SAVED = CONTAINER.innerHTML;
  }

  restoreState() {
    this.clear();
    CONTAINER.innerHTML = SAVED;
    // this.resetTagListeners();
    this.resetGacLinkListeners();
    const bookmarks = CONTAINER.querySelectorAll(".bookmark");
    for (let book of bookmarks) {
      const icon = book.querySelector(".icon");
      if (Bookmark.selection.includes(icon.getAttribute("id"))) {
        icon.classList.add("active");
      } else {
        icon.classList.remove("active");
      }
      Bookmark.activateIcon(icon.parentNode.parentNode, this);
    }
    Bookmark.HIDE_SHARING = false;
  }

  resize() {
    this.contents.forEach((content) => {
      content.resize();
    });
  }

  async introduction(clear = false) {
    // write the current week day in the date div
    if (clear) this.clear();

    const date = document.querySelector(".date");
    const dateStr = new Date().toLocaleDateString("en-US", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    date.textContent = `${dateStr}`;

    if (!clear && !this.introContent) {
      // fetch the introduction content
      this.introContent = await loadJson("./json/presentation.json");
    }

    // build intro
    const newContainer = document.createElement("div");
    newContainer.classList.add("introduction");

    this.introContent.introduction.forEach((text, index) => {
      // if (index == this.introContent.introduction.length - 1) {
      //   const ads = document.createElement("span");
      //   ads.classList.add("ads");
      //   ads.textContent = text;
      //   newContainer.appendChild(ads);
      // } else {
      // }
      newContainer.innerHTML +=
        text +
        (index < this.introContent.introduction.length - 1 ? "<hr/>" : "");
    });

    CONTAINER.appendChild(newContainer);
  }

  // Bookmark instructions
  bookmarks() {
    console.warn("content bookmark", Bookmark.selection);
    if (Bookmark.selection.length == 0) {
      this.clear();

      // display instructions
      const text = `Bookmark photos from the Daily Herald Archive to curate your own special edition. The photos you select will appear here. 
      When you are ready click share to allow others to enjoy your personalised edition of the newspaper.`;

      const headline = document.createElement("h2");
      headline.innerHTML = text.replace(/\n/g, "<br>");
      CONTAINER.appendChild(headline);
    } else {
      // display an assets list
      const title = Bookmark.HIDE_SHARING
        ? "Special edition"
        : "My Personal Edition";

      this.assets(title, Bookmark.selection.concat(), true, true);
    }
  }

  /**
   * categories is either a NUMBER of random categories
   * OR the NAME of a category
   *
   * get 3 catgeories
   *    categories = 3;
   *
   * get the "/Beauty & Fitness/Beauty Pageants" category
   *    categories = "/Beauty & Fitness/Beauty Pageants",
   *
   * how many images from this category
   *    imagesCount = 10;
   * @param {int|string} categories count or category name
   * @param {int} imagesCount int
   */
  async categories(categories = 10, imagesCount = 10, clear = false) {
    const { imagesByCat, versoIdsList } = DATA_STORE.getCategoriesContent(
      categories,
      imagesCount
    );
    await this.createContent(imagesByCat, versoIdsList, clear);
    // to avoid reloading content with infinite scroll
    this.notReady = true;
  }

  /**
   * builds a content block based on a tag
   * @param {string} tag
   */
  async tags(tag, clear = true) {
    const assets = DATA_STORE.tags[tag];
    // const maxTAG = 50;
    // assets = assets.slice(
    //   0,
    //   Math.min(DATA_STORE.tags[tag].length, maxTAG)
    // );
    const imagesDictionary = {};
    imagesDictionary["/" + tag] = assets;
    console.warn(imagesDictionary);
    await this.createContent(imagesDictionary, assets, clear);
  }

  /**
   * builds a content block based on a name and a series of asset ids
   * @param {string} name
   * @param {Array} assets
   */
  async assets(name, assets, clear = true, isBookmark = false) {
    const imagesDictionary = {};
    imagesDictionary["/" + name] = assets;
    await this.createContent(imagesDictionary, assets, clear, isBookmark);
  }

  // builds a Content object
  async createContent(imagesByCat, versoIdsList, clear = false, isBookmark) {
    if (this.loading == true) return;
    this.loading = true;

    // clear the preload pool
    this.pool.forEach((content) => {
      content.off("content-loaded-before", this.handlers.onFirstContentLoaded);
      content.off("content-loaded", this.handlers.onLodComplete);
      content.off("image-loaded", this.handlers.onProgress);
    });
    this.pool = [];

    // special case: empty search result
    const cats = imagesByCat;
    const keys = Object.keys(cats);

    const isEmptySearchResult = keys.length == 1 && cats[keys[0]].length == 0;
    if (isEmptySearchResult) {
      this.clear();
      let empty = new EmptyResult(CONTAINER, imagesByCat);
      empty.on("select", (name, assets) => {
        console.log("cat", name, assets, "search");
        this.emit("search-result", name, assets, "search");
      });
      this.loading = false;
      return;
    }

    // convert VERSO ID to RECTO ID
    const rectoIds = versoIdsList.map((verso) =>
      DATA_STORE.getAssetRecto(verso)
    );

    // create a dictionary of images images[ recto GAC_ID ] => image URL
    const imagesDict = await assetIDsToImageURLS(rectoIds);

    //once the URLS have arrived clears the page if need be (tags)
    // if (clear == true) {
    //   this.clear();
    // }
    // // delegated after laoding
    this.cleared = false;
    this.mustClear = clear;

    // create chapters by category with the related images

    // get categories keys
    const categoriesKeys = Object.keys(imagesByCat);

    // create chapters
    this.contentToBeLoaded = categoriesKeys.length;
    this.totalImages = 0;

    console.table(
      "Layout: content to create",
      this.contentToBeLoaded,
      imagesByCat
    );
    categoriesKeys.forEach((category, i) => {
      const content = new Content(
        CONTAINER,
        category,
        imagesDict,
        imagesByCat,
        this.USE_WORKER,
        i,
        isBookmark,
        this
      );
      this.pool.push(content);
      this.contents.push(content);
      this.totalImages += content.pool.length;
    });

    // load all the contents
    console.table("LAYOUT preload", this.totalImages, "images");
    this.loadedImages = 0;
    document.querySelector(".progress").innerHTML = "";
    this.onProgress();
    this.completed = false;
    this.load();
  }

  // resetTagListeners() {
  //   // let tagElements = document
  //   //   .querySelector(".letter")
  //   //   .querySelectorAll(".tag");
  //   // const callback = this.onTagClicked.bind(this);
  //   // let index = 0;
  //   // for (let tag of tagElements) {
  //   //   tag.removeEventListener("pointerdown", callback);
  //   //   tag.addEventListener("pointerdown", callback);
  //   //   setTimeout(() => {
  //   //     tag.style.opacity = 1;
  //   //   }, 500 + index * 100);
  //   //   index++;
  //   // }
  // }
  // onTagClicked(e) {
  //   const tag = e.target.getAttribute("tag");
  //   this.emit("tag-clicked", tag);
  // }

  resetGacLinkListeners() {
    let gac_links = document
      .querySelector(".letter")
      .querySelectorAll(".gac-link");
    for (let gac_link of gac_links) {
      gac_link.addEventListener("click", (e) => {
        e.preventDefault();
        console.warn("TODO: fix link");
        scroll.y = window.scrollY;
        const url = e.target.getAttribute("url");
        this.axl.sendMessage(AxL.ChildToHost.NAVIGATE, url);
      });
    }
  }

  // check images visibility
  visibilityCheck() {
    //
    requestAnimationFrame(this.visibilityCheck.bind(this));
    const { inside, outside, partial } = checkImageInViewport();

    // do something with the insiders
    inside.forEach((image) => {
      //inutile de tester, elle ne s'ajoute qu'une fois :)
      image.classList.add(image.dataset.transition);
    });

    // do something with the outsiders
    outside.forEach((image) => {
      image.classList.remove(image.dataset.transition);
    });

    // check if we need to load new content ;
    if (isScrollingToBottom()) {
      this.emit("touch-bottom");
    }

    //check if we need to add shadow to the header
    if (window.scrollY > 5) {
      document.querySelector(".card").classList.add("shadow");
    } else {
      document.querySelector(".card").classList.remove("shadow");
    }
  }

  onFirstContentLoaded() {
    if (this.mustClear === true && this.cleared === false) {
      this.clear();
      this.cleared = true;
      console.log("clear");
    }
  }

  onLodComplete() {
    this.load();
  }

  onProgress() {
    document.querySelector(".progress").innerHTML =
      this.loadedImages + " / " + this.totalImages;
    this.loadedImages++;
  }

  onContentsComplete() {
    this.completed = true;
    console.table("Layout: > all contents loaded");
    this.resize();
    // this.resetTagListeners();
    this.resetGacLinkListeners();
    this.emit("all-contents-loaded");
    this.loading = false;
  }

  load() {
    if (this.pool.length == 0) {
      if (this.completed === false) return this.onContentsComplete();
    }

    const content = this.pool.shift();
    if (content == undefined) {
      return;
    }

    console.table(
      "\tLAYOUT: loading content:",
      content.category,
      " => ",
      this.pool.length,
      "contents left"
    );
    // clears the page when the first content is loaded
    content.once("content-loaded-before", this.handlers.onFirstContentLoaded);

    // set progress
    content.on("image-loaded", this.handlers.onProgress);

    // load next
    content.on("content-loaded", this.handlers.onLodComplete);

    for (let i = 0; i < Math.min(16, content.pool.length); i++) {
      content.load();
    }
  }
}
